import type { InterludeTypes } from "@/interlude";

type ChannelSelectFooterAction = "submitRequest" | "contactUs" | "continue";

/**
 * Which primary button the footer shows for the selected channel type:
 * a request form for email without self-onboarding, contact-us for types
 * this org cannot create yet, and continue otherwise.
 */
export const getChannelSelectFooterAction = ({
  channelType,
  enableEmailChannelSelfOnboarding,
  enableLineChannelCreation,
  wccsAvailableChannelCount,
  wccsWebStreamsModuleAvailable,
}: {
  channelType: InterludeTypes["Channel"]["type"] | "web-streams";
  enableEmailChannelSelfOnboarding: boolean;
  enableLineChannelCreation: boolean;
  wccsAvailableChannelCount: number;
  wccsWebStreamsModuleAvailable: boolean;
}): ChannelSelectFooterAction => {
  if (channelType === "email" && !enableEmailChannelSelfOnboarding)
    return "submitRequest";
  if (
    (channelType === "wccs" && wccsAvailableChannelCount === 0) ||
    (channelType === "line" && !enableLineChannelCreation) ||
    (channelType === "web-streams" && !wccsWebStreamsModuleAvailable)
  )
    return "contactUs";
  return "continue";
};
